import $ from 'jquery';
import 'arrive';

$(document).ready(function () {
    document.arrive('.aw_jobList', {existing: true}, function () {
        let $job_list = $(this);
        let $job_list_search_box = $job_list.find('.aw_searchBox');
        if ($job_list_search_box.length) {
            $job_list_search_box.prependTo('#wwu_filters_box');
            let $job_list_selects = $job_list_search_box.find('select');
            $job_list_selects.wrap('<div class="srg-custom-select srg-bg-color-black"></div>');
            $job_list_selects.change(function() {
                console.log('search');
                $('.aw_searchButton button').click();
            })
        }
        let cl ='';
        $job_list.find('.aw_jobPosting .aw_location').each(function() {
            $(this).append('<span class="read-more">'+srg.readmore+'</span>');
        })
    });
});